import React, { useState } from "react";
import cx from "classnames";
import { ReactSVG } from "react-svg";

import * as styles from "./PickemsImage.module.scss";

type PickemImageProps = {
  image?: string | string[];
  className?: string;
  altText?: string;
};

const PickemImage = ({ image, className, altText = "" }: PickemImageProps) => {
  const [shouldHide, setShouldHide] = useState(false);
  const images = Array.isArray(image) ? image : [image];

  // if image errored out, do not load it
  if (shouldHide) return null;

  return (
    <div className={cx(styles.contestImage, className)}>
      {images.map((x) => {
        if (x?.endsWith(".svg")) {
          return (
            <ReactSVG
              key={x}
              src={x}
              className={styles.svgIcon}
              style={{
                width: images.length < 3 ? "3.125rem" : "2rem",
              }}
            />
          );
        }

        return (
          <img
            alt={altText}
            key={x}
            src={x}
            style={{
              maxWidth: `calc(100% / ${images.length})`,
              maxHeight: images.length < 4 ? "100%" : "50%",
            }}
            onError={(_) => {
              setShouldHide(true);
            }}
          />
        );
      })}
    </div>
  );
};

export { PickemImage };
